interface BrandingColors {
  primary?: string;
  secondary?: string;
  accent?: string;
  background?: string;
  text?: string;
}

interface BrandingConfig {
  name?: string;
  colors?: BrandingColors;
}

const COLOR_MAP: Record<keyof BrandingColors, string> = {
  primary: '--accent',
  secondary: '--accent-secondary',
  accent: '--accent-emphasis',
  background: '--bg',
  text: '--fg'
};

export async function loadBranding(): Promise<void> {
  try {
    const response = await fetch('/branding.json', { cache: 'no-store' });
    if (!response.ok) {
      return;
    }

    const config = (await response.json()) as BrandingConfig;
    if (!config.colors) {
      return;
    }

    const root = document.documentElement;
    for (const [key, cssVar] of Object.entries(COLOR_MAP)) {
      const value = config.colors[key as keyof BrandingColors];
      if (value) {
        root.style.setProperty(cssVar, value as string);
      }
    }
  } catch (error) {
    console.warn('Failed to load builder branding config', error);
  }
}
